import React from "react"; // Import React library for building user interfaces
import { useIntl } from "react-intl"; // Import the useIntl hook for internationalization

/**
 * LegendToggleButton Component
 *
 * This component renders a button that toggles the position of the legend
 * in a Plotly chart. The button text is dynamically generated based on the
 * current position of the legend (above or below the chart) and supports
 * internationalization using react-intl.
 *
 * Props:
 * - setIsLegendAbove: A function that toggles the legend's position
 *   when the button is clicked.
 * - isLegendAbove: A boolean that indicates whether the legend is currently
 *   positioned above the chart.
 */
const LegendToggleButton = ({ setIsLegendAbove, isLegendAbove }) => {
  const intl = useIntl(); // Use the useIntl hook to access the intl object for formatting messages

  return (
    <button
      onClick={() => setIsLegendAbove((prev) => !prev)} // Call the toggle function when the button is clicked
      style={{ marginBottom: "10px" }} // Apply bottom margin for spacing
    >
      {isLegendAbove
        ? intl.formatMessage({ id: "toggleLegendAbove" }) // Display message for moving legend below
        : intl.formatMessage({ id: "toggleLegendBelow" })}{" "}
      {/* Display message for moving legend above*/}
    </button>
  );
};

export default LegendToggleButton; // Export the component for use in other parts of the application
